const DEV_BACKEND_PORT = "3001";
const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

const isBrowser = () => typeof window !== "undefined";

export const getDevBackendHttpBaseUrl = (locationLike) => {
  if (!locationLike) return "";
  const { protocol, hostname, port } = locationLike;
  if (process.env.NODE_ENV === "production") return "";
  if (!LOCAL_DEV_HOSTS.has(hostname)) return "";
  if (!port || port === DEV_BACKEND_PORT) return "";
  return `${protocol}//${hostname}:${DEV_BACKEND_PORT}`;
};

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (!isBrowser()) return "";
  return getDevBackendHttpBaseUrl(window.location) || "";
};

export const getWebSocketRuntimeUrl = (locationLike) => {
  if (!locationLike) return "";

  const devBaseUrl = getDevBackendHttpBaseUrl(locationLike);
  if (devBaseUrl) {
    return devBaseUrl.replace(/^http/, "ws");
  }

  const protocol = locationLike.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${locationLike.host}`;
};
